<!-- -------------------------------------------------------------- -->
<!-- confirm delete dialog -->
<!-- -------------------------------------------------------------- -->
<p class="p-x-24 f-s-14 p-y-24">Are you sure you want to delete this invoice?</p>
<mat-dialog-actions>
  <button mat-flat-button class="bg-error text-white" (click)="onConfirm()">Delete</button>
  <button mat-flat-button (click)="onCancel()">Cancel</button>
</mat-dialog-actions>